// // // import React, { useState, useRef } from "react";
// // // import emailjs from "@emailjs/browser";
// // // import { FaEye, FaHeart } from "react-icons/fa";
// // // import { Swiper, SwiperSlide } from "swiper/react";
// // // import { Navigation } from "swiper";
// // // import "swiper/css";
// // // import "swiper/css/navigation";

// // // // ✅ Product Data
// // // const allProducts = [
// // //   {
// // //     id: 1,
// // //     name: "Apricot Delight Cake (Large)",
// // //     price: 1950,
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 2,
// // //     name: "Apricot Delight Cake (Medium)",
// // //     price: 1390,
// // //     category: "Cakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 3,
// // //     name: "Chocolate Pastry",
// // //     price: 180,
// // //     category: "Pastries",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 4,
// // //     name: "Vanilla Muffin",
// // //     price: 120,
// // //     category: "Muffins",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // //   {
// // //     id: 5,
// // //     name: "Red Velvet Cupcake",
// // //     price: 150,
// // //     category: "Cupcakes",
// // //     image:
// // //       "http://bakelore.com/images/apricot_delight_bakelore.webp",
// // //   },
// // // ];

// // // const TrendingProducts = () => {
// // //   const [selectedProduct, setSelectedProduct] = useState(null);
// // //   const [showForm, setShowForm] = useState(false);
// // //   const [category, setCategory] = useState("Cakes");
// // //   const [formData, setFormData] = useState({
// // //     name: "",
// // //     contact: "",
// // //     email: "",
// // //     message: "",
// // //     product: "",
// // //   });

// // //   const prevRef = useRef(null);
// // //   const nextRef = useRef(null);

// // //   // ✅ Filter products by category
// // //   const filteredProducts =
// // //     category === "All"
// // //       ? allProducts
// // //       : allProducts.filter((p) => p.category === category);

// // //   const handleFormSubmit = (e) => {
// // //     e.preventDefault();
// // //     emailjs
// // //       .send("YOUR_SERVICE_ID", "YOUR_TEMPLATE_ID", formData, "YOUR_PUBLIC_KEY")
// // //       .then(
// // //         () => {
// // //           alert("✅ Order submitted successfully!");
// // //           setShowForm(false);
// // //           setFormData({
// // //             name: "",
// // //             contact: "",
// // //             email: "",
// // //             message: "",
// // //             product: "",
// // //           });
// // //         },
// // //         (error) => {
// // //           console.error("❌ Error sending form:", error);
// // //           alert("Something went wrong. Please try again.");
// // //         }
// // //       );
// // //   };

// // //   return (
// // //     <div className="bg-[#faf7f2] min-h-screen flex flex-col items-center py-14 px-6 relative">
// // //       {/* ✅ Heading */}
// // //       <h2 className="text-3xl md:text-4xl font-semibold tracking-wide text-gray-800 text-center mb-6">
// // //         Trending Products
// // //       </h2>

// // //       {/* ✅ Category Tabs */}
// // //       <div className="flex justify-center gap-6 mb-10">
// // //         {["Cakes", "Pastries", "Muffins"].map((cat) => (
// // //           <button
// // //             key={cat}
// // //             onClick={() => setCategory(cat)}
// // //             className={`px-5 py-2 rounded-full font-medium border transition-all duration-300 ${
// // //               category === cat
// // //                 ? "bg-[#b27d73] text-white border-[#b27d73]"
// // //                 : "border-gray-400 text-gray-700 hover:bg-[#b27d73]/10"
// // //             }`}
// // //           >
// // //             {cat}
// // //           </button>
// // //         ))}
// // //       </div>

// // //       {/* ✅ Desktop Grid */}
// // //       <div className="hidden sm:grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-7xl w-full">
// // //         {filteredProducts.map((product) => (
// // //           <ProductCard
// // //             key={product.id}
// // //             product={product}
// // //             setFormData={setFormData}
// // //             setShowForm={setShowForm}
// // //             setSelectedProduct={setSelectedProduct}
// // //           />
// // //         ))}
// // //       </div>

// // //       {/* ✅ Mobile Swiper */}
// // //       <div className="block sm:hidden w-full max-w-xs relative">
// // //         <button
// // //           ref={prevRef}
// // //           className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-3 bg-[#b27d73] text-white w-9 h-9 rounded-full flex items-center justify-center shadow-md active:scale-90 z-10"
// // //         >
// // //           ❮
// // //         </button>
// // //         <button
// // //           ref={nextRef}
// // //           className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-3 bg-[#b27d73] text-white w-9 h-9 rounded-full flex items-center justify-center shadow-md active:scale-90 z-10"
// // //         >
// // //           ❯
// // //         </button>

// // //         <Swiper
// // //           modules={[Navigation]}
// // //           spaceBetween={20}
// // //           slidesPerView={1}
// // //           navigation={{
// // //             prevEl: prevRef.current,
// // //             nextEl: nextRef.current,
// // //           }}
// // //           onBeforeInit={(swiper) => {
// // //             swiper.params.navigation.prevEl = prevRef.current;
// // //             swiper.params.navigation.nextEl = nextRef.current;
// // //           }}
// // //           className="w-full"
// // //         >
// // //           {filteredProducts.map((product) => (
// // //             <SwiperSlide key={product.id}>
// // //               <ProductCard
// // //                 product={product}
// // //                 setFormData={setFormData}
// // //                 setShowForm={setShowForm}
// // //                 setSelectedProduct={setSelectedProduct}
// // //               />
// // //             </SwiperSlide>
// // //           ))}
// // //         </Swiper>
// // //       </div>

// // //       {/* ✅ Popup Form */}
// // //       {showForm && (
// // //         <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50">
// // //           <form
// // //             onSubmit={handleFormSubmit}
// // //             className="bg-white rounded-lg w-[90%] max-w-md p-6 relative animate-fadeIn"
// // //           >
// // //             <button
// // //               className="absolute top-3 right-4 text-gray-500 hover:text-black text-xl"
// // //               onClick={() => setShowForm(false)}
// // //               type="button"
// // //             >
// // //               ✕
// // //             </button>

// // //             <h2 className="text-2xl font-semibold mb-4 text-center text-[#b27d73]">
// // //               Order Form
// // //             </h2>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Name</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.name}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, name: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Contact</label>
// // //               <input
// // //                 type="text"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.contact}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, contact: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Email</label>
// // //               <input
// // //                 type="email"
// // //                 required
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.email}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, email: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <div className="mb-3">
// // //               <label className="block text-gray-700 mb-1">Product</label>
// // //               <input
// // //                 type="text"
// // //                 readOnly
// // //                 className="w-full border px-3 py-2 rounded bg-gray-100"
// // //                 value={formData.product}
// // //               />
// // //             </div>

// // //             <div className="mb-4">
// // //               <label className="block text-gray-700 mb-1">Message</label>
// // //               <textarea
// // //                 rows="3"
// // //                 className="w-full border px-3 py-2 rounded"
// // //                 value={formData.message}
// // //                 onChange={(e) =>
// // //                   setFormData({ ...formData, message: e.target.value })
// // //                 }
// // //               />
// // //             </div>

// // //             <button
// // //               type="submit"
// // //               className="bg-[#b27d73] text-white px-6 py-2 w-full rounded hover:bg-[#a76d63]"
// // //             >
// // //               Submit
// // //             </button>
// // //           </form>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // };

// // // // ✅ Product Card Component
// // // const ProductCard = ({
// // //   product,
// // //   setFormData,
// // //   setShowForm,
// // //   setSelectedProduct,
// // // }) => (
// // //   <div className="bg-white shadow-md rounded-lg overflow-hidden hover:shadow-lg transition-all duration-300 group">
// // //     <div className="relative overflow-hidden">
// // //       <img
// // //         src={product.image}
// // //         alt={product.name}
// // //         className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
// // //       />
// // //       <div className="absolute inset-0 bg-white/80 opacity-0 group-hover:opacity-100 transition-all flex justify-center items-center gap-4">
// // //         <button
// // //           onClick={() => setSelectedProduct(product)}
// // //           className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]"
// // //         >
// // //           <FaEye size={16} />
// // //         </button>
// // //         <button className="w-10 h-10 bg-white border border-gray-400 rounded flex items-center justify-center hover:bg-[#d6aaa3]">
// // //           <FaHeart size={16} />
// // //         </button>
// // //       </div>
// // //     </div>

// // //     <div className="text-center py-5">
// // //       <p className="text-lg text-gray-800 font-medium">{product.name}</p>
// // //       <p className="text-[#b27d73] font-semibold text-lg mt-1">
// // //         Rs. {product.price.toFixed(2)}
// // //       </p>

// // //       <button
// // //         onClick={() => {
// // //           setFormData((prev) => ({ ...prev, product: product.name }));
// // //           setShowForm(true);
// // //         }}
// // //         className="mt-3 bg-[#b27d73] text-white px-6 py-2 rounded text-sm font-semibold hover:bg-[#a37368] transition"
// // //       >
// // //         ORDER NOW
// // //       </button>
// // //     </div>
// // //   </div>
// // // );

// // // export default TrendingProducts;


// // import React from "react";
// // import { Link } from "react-router-dom";

// // // ✅ Product Data
// // const ramzanProducts = [
// //   {
// //     id: 1,
// //     name: "Ramzan Special Combo",
// //     image: "https://bakelore.com/images/ramadan-season-menu-offer-card.jpeg", // put your banner style image
// //     link: "/ramzan-special-food",
// //   },
// //   {
// //     id: 2,
// //     name: "Mutton Haleem & Chicken 65 Bun",
// //     image: "https://bakelore.com/images/Mutton-Haleem&Chicken-65-Bun.webp",
// //     link: "/#",
// //   },
// //   {
// //     id: 3,
// //     name: "Baklava Rolls - 550 Grams",
// //     image: "https://bakelore.com/images/Baklava-Rolls.webp",
// //     link: "/#",
// //   },
// //   {
// //     id: 4,
// //     name: "Jewel of Arabian Dream Cake",
// //     image: "https://bakelore.com/images/Jewel -of-Arabian-Dream-Cake.webp",
// //     link: "/#",
// //   },
// // ];

// // const RamzanSpecial = () => {
// //   return (
// //     <div className="bg-[#faf7f2] py-16 px-6">

// //       {/* Heading */}
// //       <div className="text-center mb-12">
// //         <h2 className="text-4xl md:text-5xl font-bold text-[#b27d73] tracking-wide">
// //           🌙 Ramzan Special
// //         </h2>
// //         <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
// //           Celebrate this holy season with our exclusive Ramzan delights,
// //           specially prepared for your Iftar gatherings.
// //         </p>
// //       </div>

// //       {/* Grid */}
// //       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
// //         {ramzanProducts.map((product, index) =>
// //           index === 0 ? (
// //             <ImageOnlyCard key={product.id} product={product} />
// //           ) : (
// //             <ProductCard key={product.id} product={product} />
// //           )
// //         )}
// //       </div>
// //     </div>
// //   );
// // };



// // // ✅ First Card – Image Only
// // const ImageOnlyCard = ({ product }) => {
// //   return (
// //     <Link to={product.link} className="block h-full">
// //       <div className="rounded-xl overflow-hidden shadow-md hover:shadow-xl transition duration-300 h-full">
// //         <img
// //           src={product.image}
// //           alt={product.name}
// //           className="w-full h-[450px] object-cover hover:scale-105 transition duration-500"
// //         />
// //       </div>
// //     </Link>
// //   );
// // };



// // // ✅ Other Cards
// // const ProductCard = ({ product }) => {
// //   return (
// //     <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition duration-300 flex flex-col h-full">

// //       {/* Image */}
// //       <div className="overflow-hidden">
// //         <img
// //           src={product.image}
// //           alt={product.name}
// //           className="w-full h-[260px] object-cover hover:scale-105 transition duration-500"
// //         />
// //       </div>

// //       {/* Content */}
// //       <div className="flex flex-col justify-between flex-grow p-6 text-center">

// //         <h3 className="text-lg font-semibold text-gray-800">
// //           {product.name}
// //         </h3>

// //         <Link to={product.link}>
// //           <button className="mt-6 bg-[#b27d73] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#a37368] transition duration-300 w-full">
// //             ORDER NOW
// //           </button>
// //         </Link>

// //       </div>
// //     </div>
// //   );
// // };

// // export default RamzanSpecial;


// // import React from "react";
// // import { Link } from "react-router-dom";

// // // ✅ Product Data
// // const ramzanProducts = [
// //   {
// //     id: 1,
// //     name: "Ramzan Special Combo",
// //     image: "https://bakelore.com/images/ramadan-season-menu-offer-card.jpeg",
// //     link: "/ramzan-special-food",
// //     external: false,
// //   },
// //   {
// //     id: 2,
// //     name: "Mutton Haleem & Chicken 65 Bun",
// //     image: "https://bakelore.com/images/Mutton-Haleem&Chicken-65-Bun.webp",
// //     link: "#",
// //     external: true,
// //   },
// //   {
// //     id: 3,
// //     name: "Baklava Rolls - 550 Grams",
// //     image: "https://bakelore.com/images/Baklava-Rolls.webp",
// //     link: "#",
// //     external: true,
// //   },
// //   {
// //     id: 4,
// //     name: "Jewel of Arabian Dream Cake",
// //     image: "https://bakelore.com/images/Jewel -of-Arabian-Dream-Cake.webp",
// //     link: "#",
// //     external: true,
// //   },
// // ];

// // const RamzanSpecial = () => {
// //   return (
// //     <div className="bg-[#faf7f2] py-16 px-6">
      
// //       {/* Heading */}
// //       <div className="text-center mb-12">
// //         <h2 className="text-4xl md:text-5xl font-bold text-[#b27d73] tracking-wide">
// //           🌙 Ramzan Special
// //         </h2>
// //         <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
// //           Celebrate this holy season with our exclusive Ramzan delights,
// //           specially prepared for your Iftar gatherings.
// //         </p>
// //       </div>

// //       {/* Grid */}
// //       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
// //         {ramzanProducts.map((product, index) =>
// //           index === 0 ? (
// //             <ImageOnlyCard key={product.id} product={product} />
// //           ) : (
// //             <ProductCard key={product.id} product={product} />
// //           )
// //         )}
// //       </div>
// //     </div>
// //   );
// // };



// // // ✅ First Card – Image Only
// // const ImageOnlyCard = ({ product }) => {
// //   if (product.external) {
// //     return (
// //       <a
// //         href={product.link}
// //         target="_blank"
// //         rel="noopener noreferrer"
// //         className="block h-full"
// //       >
// //         <div className="rounded-xl overflow-hidden shadow-md hover:shadow-xl transition duration-300 h-full">
// //           <img
// //             src={product.image}
// //             alt={product.name}
// //             className="w-full h-[450px] object-cover hover:scale-105 transition duration-500"
// //           />
// //         </div>
// //       </a>
// //     );
// //   }

// //   return (
// //     <Link to={product.link} className="block h-full">
// //       <div className="rounded-xl overflow-hidden shadow-md hover:shadow-xl transition duration-300 h-full">
// //         <img
// //           src={product.image}
// //           alt={product.name}
// //           className="w-full h-[450px] object-cover hover:scale-105 transition duration-500"
// //         />
// //       </div>
// //     </Link>
// //   );
// // };



// // // ✅ Other Cards
// // const ProductCard = ({ product }) => {
// //   return (
// //     <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition duration-300 flex flex-col h-full">

// //       {/* Image */}
// //       <div className="overflow-hidden">
// //         <img
// //           src={product.image}
// //           alt={product.name}
// //           className="w-full h-[260px] object-cover hover:scale-105 transition duration-500"
// //         />
// //       </div>

// //       {/* Content */}
// //       <div className="flex flex-col justify-between flex-grow p-6 text-center">

// //         <h3 className="text-lg font-semibold text-gray-800">
// //           {product.name}
// //         </h3>

// //         {product.external ? (
// //           <a
// //             href={product.link}
// //             target="_blank"
// //             rel="noopener noreferrer"
// //           >
// //             <button className="mt-6 bg-[#b27d73] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#a37368] transition duration-300 w-full">
// //               ORDER NOW
// //             </button>
// //           </a>
// //         ) : (
// //           <Link to={product.link}>
// //             <button className="mt-6 bg-[#b27d73] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#a37368] transition duration-300 w-full">
// //               ORDER NOW
// //             </button>
// //           </Link>
// //         )}

// //       </div>
// //     </div>
// //   );
// // };

// // export default RamzanSpecial;


// import React from "react";
// import { Link } from "react-router-dom";

// // ✅ Product Data
// const ramzanProducts = [
//   {
//     id: 1,
//     name: "Ramzan Special Combo",
//     image: "https://bakelore.com/images/ramadan-season-menu-offer-card.jpeg",
//     link: "/ramzan-special-food",
//     external: false,
//   },
//   {
//     id: 2,
//     name: "Mutton Haleem & Chicken 65 Bun",
//     image: "https://bakelore.com/images/Mutton-Haleem&Chicken-65-Bun.webp",
//     link: "#",
//     external: true,
//   },
//   {
//     id: 3,
//     name: "Baklava Rolls - 550 Grams",
//     image: "https://bakelore.com/images/Baklava-Rolls.webp",
//     link: "#",
//     external: true,
//   },
//   {
//     id: 4,
//     name: "Jewel of Arabian Dream Cake",
//     image: "https://bakelore.com/images/Jewel -of-Arabian-Dream-Cake.webp",
//     link: "#",
//     external: true,
//   },
// ];

// const RamzanSpecial = () => {
//   return (
//     <div className="bg-[#faf7f2] py-16 px-6">

//       {/* Heading */}
//       <div className="text-center mb-12">
//         <h2 className="text-4xl md:text-5xl font-bold text-[#b27d73] tracking-wide">
//           🌙 Ramzan Special
//         </h2>
//         <p className="text-gray-600 mt-4 max-w-2xl mx-auto">
//           Celebrate this holy season with our exclusive Ramzan delights,
//           specially prepared for your Iftar gatherings.
//         </p>
//       </div>

//       {/* Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
//         {ramzanProducts.slice(1).map((product) => (
//           <ProductCard key={product.id} product={product} />
//         ))}
//       </div>

//     </div>
//   );
// };


// // ✅ Product Card
// const ProductCard = ({ product }) => {
//   return (
//     <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition duration-300 flex flex-col h-full">

//       {/* Image */}
//       <div className="overflow-hidden">
//         <img
//           src={product.image}
//           alt={product.name}
//           className="w-full h-[260px] object-cover hover:scale-105 transition duration-500"
//         />
//       </div>

//       {/* Content */}
//       <div className="flex flex-col justify-between flex-grow p-6 text-center">

//         <h3 className="text-lg font-semibold text-gray-800">
//           {product.name}
//         </h3>

//         {product.external ? (
//           <a
//             href={product.link}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             <button className="mt-6 bg-[#b27d73] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#a37368] transition duration-300 w-full">
//               ORDER NOW
//             </button>
//           </a>
//         ) : (
//           <Link to={product.link}>
//             <button className="mt-6 bg-[#b27d73] text-white px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#a37368] transition duration-300 w-full">
//               ORDER NOW
//             </button>
//           </Link>
//         )}

//       </div>
//     </div>
//   );
// };

// export default RamzanSpecial;


// import React from "react";

// // ✅ Brand Colors
// const BRAND = {
//   primary: "#b27d73",
//   secondary: "#faf7f2",
//   buttonHover: "#a37368",
//   textDark: "#3d2c28",
// };

// // ✅ EKSECOND WhatsApp Redirect Link
// const EKSECOND_LINK =
//   "#";

// // ✅ Mango Season Special Products
// const mangoProducts = [
//   {
//     id: 1,
//     name: "Mango Bento Cake",
//     description:
//       "Vanilla sponge cake infused with mango syrup, layered with mango cream, and topped with fresh mango slices drizzled with mango pulp.",
//     image:
//       "https://images.unsplash.com/photo-1621303837174-89787a7d4729?q=80&w=1200&auto=format&fit=crop",
//   },
//   {
//     id: 2,
//     name: "Mango Cheese Cake Jar",
//     description:
//       "Eggless & no bake cheesecake adorned with juicy mango chunks and a drizzle of mango pulp.",
//     image:
//       "https://images.unsplash.com/photo-1565958011703-44f9829ba187?q=80&w=1200&auto=format&fit=crop",
//   },
//   {
//     id: 3,
//     name: "Mango Cream Tresleches",
//     description:
//       "Eggless vanilla sponge cake delicately soaked in mango syrup milk, generously layered with creamy mango filling, and elegantly topped with luscious mango chunks and pulp.",
//     image:
//       "https://images.unsplash.com/photo-1578985545062-69928b1d9587?q=80&w=1200&auto=format&fit=crop",
//   },
//   {
//     id: 4,
//     name: "Mango Roulade",
//     description:
//       "A vanilla sponge infused with mango syrup, layered with succulent mango chunks, topped with mango cream, and garnished with a delicate drizzle of mango pulp.",
//     image:
//       "https://images.unsplash.com/photo-1551024506-0bccd828d307?q=80&w=1200&auto=format&fit=crop",
//   },
//   {
//     id: 5,
//     name: "Mango Delight",
//     description:
//       "Vanilla sponge infused with mango syrup, layered with mango pudding, and finished with a decadent topping of mango pulp.",
//     image:
//       "https://images.unsplash.com/photo-1464306076886-da185f6a9d05?q=80&w=1200&auto=format&fit=crop",
//   },
// ];

// const MangoSeasonSpecial = () => {
//   return (
//     <div
//       className="py-16 px-6"
//       style={{ backgroundColor: BRAND.secondary }}
//     >
//       {/* Heading */}
//       <div className="text-center mb-14">
//         <h2
//           className="text-4xl md:text-5xl font-bold tracking-wide"
//           style={{ color: BRAND.primary }}
//         >
//           🥭 Mango Season Specials
//         </h2>

//         <p
//           className="mt-4 max-w-2xl mx-auto text-lg"
//           style={{ color: "#666" }}
//         >
//           Dive into the king of fruits with our refreshing seasonal mango
//           desserts crafted specially for this summer trend.
//         </p>
//       </div>

//       {/* Product Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
//         {mangoProducts.map((product) => (
//           <ProductCard key={product.id} product={product} />
//         ))}
//       </div>
//     </div>
//   );
// };

// // ✅ Product Card
// const ProductCard = ({ product }) => {
//   return (
//     <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition duration-300 flex flex-col h-full group">
      
//       {/* Product Image */}
//       <div className="overflow-hidden">
//         <img
//           src={product.image}
//           alt={product.name}
//           className="w-full h-[280px] object-cover group-hover:scale-105 transition duration-500"
//         />
//       </div>

//       {/* Content */}
//       <div className="p-6 flex flex-col flex-grow text-center">
        
//         <h3
//           className="text-2xl font-bold mb-3"
//           style={{ color: BRAND.primary }}
//         >
//           {product.name}
//         </h3>

//         <p
//           className="text-sm leading-relaxed flex-grow"
//           style={{ color: BRAND.textDark }}
//         >
//           {product.description}
//         </p>

//         {/* WhatsApp Redirect Button */}
//         <a
//           href={EKSECOND_LINK}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <button
//             className="mt-6 text-white px-6 py-3 rounded-full font-semibold transition duration-300 w-full"
//             style={{ backgroundColor: BRAND.primary }}
//             onMouseOver={(e) =>
//               (e.currentTarget.style.backgroundColor =
//                 BRAND.buttonHover)
//             }
//             onMouseOut={(e) =>
//               (e.currentTarget.style.backgroundColor =
//                 BRAND.primary)
//             }
//           >
//             ORDER NOW
//           </button>
//         </a>
//       </div>
//     </div>
//   );
// };

// export default MangoSeasonSpecial;


import React from "react";

// ✅ Brand Colors
const BRAND = {
  primary: "#b27d73",
  secondary: "#faf7f2",
  buttonHover: "#a37368",
  textDark: "#3d2c28",
};

// ✅ EKSECOND WhatsApp Redirect Link
const EKSECOND_LINK =
  "#";

// ✅ Mango Season Special Products
const mangoProducts = [
  {
    id: 1,
    name: "Mango Bento Cake",
    description:
      "Vanilla sponge cake infused with mango syrup, layered with mango cream, and topped with fresh mango slices drizzled with mango pulp.",
    image: "https://bakelore.com/images/Mango-Bento-Cake.webp",
  },
  {
    id: 2,
    name: "Mango Cheese Cake Jar",
    description:
      "Eggless & no bake cheesecake adorned with juicy mango chunks and a drizzle of mango pulp.",
    image: "https://bakelore.com/images/Mango-Cheese-Cake-Jar.webp",
  },
  {
    id: 3,
    name: "Mango Cream Tresleches",
    description:
      "Eggless vanilla sponge cake delicately soaked in mango syrup milk, generously layered with creamy mango filling, and elegantly topped with luscious mango chunks and pulp.",
    image: "https://bakelore.com/images/Mango-Cream-Tresleches.webp",
  },
  {
    id: 4,
    name: "Mango Roulade",
    description:
      "A vanilla sponge infused with mango syrup, layered with succulent mango chunks, topped with mango cream, and garnished with a delicate drizzle of mango pulp.",
    image: "https://bakelore.com/images/Mango-Roulade.webp",
  },
  {
    id: 5,
    name: "Mango Delight",
    description:
      "Vanilla sponge infused with mango syrup, layered with mango pudding, and finished with a decadent topping of mango pulp.",
    image: "https://bakelore.com/images/Mango-Delight.webp",
  },
];

const MangoSeasonSpecial = () => {
  return (
    <div
      className="py-16 px-6"
      style={{ backgroundColor: BRAND.secondary }}
    >
      {/* Heading */}
      <div className="text-center mb-14">
        <h2
          className="text-4xl md:text-5xl font-bold tracking-wide"
          style={{ color: BRAND.primary }}
        >
          🥭 Mango Season Specials
        </h2>

        <p
          className="mt-4 max-w-2xl mx-auto text-lg"
          style={{ color: "#666" }}
        >
          Dive into the king of fruits with our refreshing seasonal mango
          desserts crafted specially for this summer trend.
        </p>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {mangoProducts.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
};

// ✅ Product Card
const ProductCard = ({ product }) => {
  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition duration-300 flex flex-col h-full group">
      
      {/* Product Image */}
      <div className="overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-[280px] object-cover group-hover:scale-105 transition duration-500"
        />
      </div>

      {/* Content */}
      <div className="p-6 flex flex-col flex-grow text-center">
        
        <h3
          className="text-2xl font-bold mb-3"
          style={{ color: BRAND.primary }}
        >
          {product.name}
        </h3>

        <p
          className="text-sm leading-relaxed flex-grow"
          style={{ color: BRAND.textDark }}
        >
          {product.description}
        </p>

        {/* WhatsApp Redirect Button */}
        <a
          href={EKSECOND_LINK}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="mt-6 text-white px-6 py-3 rounded-full font-semibold transition duration-300 w-full"
            style={{ backgroundColor: BRAND.primary }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor =
                BRAND.buttonHover)
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.backgroundColor =
                BRAND.primary)
            }
          >
            ORDER NOW
          </button>
        </a>
      </div>
    </div>
  );
};

export default MangoSeasonSpecial;